import { useNavigate } from "react-router-dom";
import { Button } from "shared/ui/button";
import { useMobile } from "shared/lib/hooks";
import { useScrollLock } from "shared/lib/hooks";
import { HOME_ROUTE } from "shared/config/routes";
import { useUserStore } from "entities/user";
import { LK_PROFILE_ROUTE } from "shared/config/routes";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import { useModal } from "shared/ui/modal";
import MapPin from "shared/assets/images/Map_pin.svg";
import UserWhite from "../assets/User_white.svg";
import UserHover from "../assets/User-hover.svg";
import Arrow from "../assets/Arrow.svg";
import styles from "./NavigationSidebar.module.scss";

export const NavigationSidebar = ({
  isCollapsed,
  open,
  close,
  toggle,
  loginSidebarOpen,
  loginSidebarClose,
  isLoginSidebarCollapsed,
}) => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useUserStore();

  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  const isMobile = useMobile("393px");
  useScrollLock(!isCollapsed);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      close?.();
    }
  };

  const handleProfileClick = async () => {
    if (!isAuthenticated) {
      if (isLoginSidebarCollapsed) {
        loginSidebarOpen?.();
      } else loginSidebarClose?.();
      return;
    }

    navigate(LK_PROFILE_ROUTE);
    close?.();
  };

  return (
    <>
      {isCollapsed ? null : (
        <div className={styles.sidebarOverlay} onClick={handleOverlayClick}>
          <div className={styles.sidebarContainer}>
            <div className={styles.sidebarWrapper}>
              <div className={styles.buttons}>
                <Button
                  variant="ghost"
                  size="small"
                  leftIcon={<img src={MapPin} alt="map pin" height={26} />}
                  onClick={openDisabledElementModal}
                >
                  Самара
                </Button>
              </div>
              <div className={styles.links}>
                <a
                  href={`${HOME_ROUTE}#about`}
                  className={styles.links__link}
                  onClick={close}
                >
                  О нас
                </a>
                <div className={styles.links__linksBlock}>
                  <a
                    href={`${HOME_ROUTE}#products`}
                    className={styles.links__link}
                    onClick={close}
                  >
                    Каталог
                  </a>
                  <img src={Arrow} alt="Arrow" />
                </div>
                <a
                  href={`${HOME_ROUTE}#brands`}
                  className={styles.links__link}
                  onClick={close}
                >
                  Бренды
                </a>
                <a
                  href={`${HOME_ROUTE}#blog`}
                  className={styles.links__link}
                  onClick={close}
                >
                  Новости
                </a>
                <a
                  className={styles.links__link}
                  onClick={openDisabledElementModal}
                >
                  Контакты
                </a>
                <a
                  className={styles.links__link}
                  onClick={openDisabledElementModal}
                >
                  Сертификаты
                </a>
                {isMobile ? (
                  <div className={styles.links__info}>
                    <a
                      className={styles.links__linkSmall}
                      onClick={openDisabledElementModal}
                    >
                      Доставка
                    </a>
                    <a
                      className={styles.links__linkSmall}
                      onClick={openDisabledElementModal}
                    >
                      Партнерская программа
                    </a>
                  </div>
                ) : (
                  <div className={styles.links__info}>
                    <a
                      className={styles.links__linkSmall}
                      onClick={openDisabledElementModal}
                    >
                      Доставка
                    </a>
                    <a
                      className={styles.links__linkSmall}
                      onClick={openDisabledElementModal}
                    >
                      Партнерская программа
                    </a>
                    <a
                      className={styles.links__linkSmall}
                      onClick={openDisabledElementModal}
                    >
                      Заказы
                    </a>
                    <a
                      className={styles.links__linkSmall}
                      onClick={openDisabledElementModal}
                    >
                      Платежи
                    </a>
                  </div>
                )}
              </div>
              <div className={styles.sidebarWrapper__adress}>
                <p>
                  Адрес: Самарская область, г. Самара, <br /> ул. Ново-садовая
                  д. 201А
                </p>
              </div>
              <div className={styles.sidebarWrapper__buttonBlock}>
                {!isAuthenticated ? (
                  <div className={styles.sidebarWrapper__centerBtn}>
                    <Button
                      variant="primary"
                      size="large"
                      leftIcon={<img src={UserWhite} alt="user" height={26} />}
                      onClick={handleProfileClick}
                    >
                      Войти в личный кабинет
                    </Button>
                  </div>
                ) : (
                  <div className={styles.sidebarWrapper__fullWidthBtn}>
                    <Button
                      variant="ghost"
                      size="large"
                      leftIcon={<img src={UserHover} alt="user" height={26} />}
                      onClick={handleProfileClick}
                    >
                      {user?.email}
                    </Button>
                    <img src={Arrow} alt="Arrow" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
